import { ManagerResponseDto } from "../../services/dto/response/manager-response-dto";
import { useFlowPages } from "../../hooks/useFlowPages";

interface AddManagerFormProps {
  setIsModalOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  onAddManager?: (newManager: ManagerResponseDto) => void;
  fetchManagers?: () => Promise<void>;
}

/**
 * Componente wrapper que renderiza el formulario de creación de manager
 * según el país del usuario (Argentina o República Dominicana)
 */
export function AddManagerForm({
  setIsModalOpen,
  onAddManager,
  fetchManagers,
}: AddManagerFormProps) {
  const FormComponent = useFlowPages({
    page: 'addManagerForm',
    props: {
      setIsModalOpen,
      onAddManager,
      fetchManagers,
    }
  });

  return <>{FormComponent}</>;
} 